import { LocaleData } from './types';

export const locales: LocaleData = {
  en: {
    signIn: "Sign In with Joisst",
    continue: "Continue as",
    dashboard: "CleanTXT",
    adminPanel: "Admin Panel",
    welcome: "Welcome back",
    hearts: "Hearts",
    brains: "Brains",
    loading: "Loading...",
    logout: "Sign out",
    usersList: "Local User Management",
    id: "ID",
    email: "Email (Masked)",
    role: "Role",
    admin: "Admin",
    user: "User",
    lastLogin: "Last Login",
    balance: "Balance",
    tagline: "Fast, minimal text cleaning for the modern web. Clean up your copy in seconds.",
    instruction: "Paste your text below and select how you want it cleaned.",
    searchPlaceholder: "Search by ID or email...",
    actions: "Actions",
    toggleAdmin: "Toggle Admin",
    save: "Save",
    cancel: "Cancel",
    testPage: "System Test Tool",
    apiData: "Raw API Data",
    spendHeart: "Spend 1 Heart",
    spendBrain: "Spend 1 Brain",
    inputLabel: "Input Text",
    outputLabel: "Cleaned Output",
    clearAll: "Clear",
    copyText: "Copy to Clipboard",
    copied: "Copied!",
    removeExtraSpaces: "Remove extra spaces",
    removeExtraLineBreaks: "Remove extra line breaks",
    removeLineBreaks: "Remove all line breaks",
    trimWhitespace: "Trim spaces at start and end",
    normalizeQuotes: "Convert curly quotes to straight quotes",
    removeTabs: "Replace tabs with spaces",
    removeEmojis: "Remove emojis",
    removeHidden: "Remove hidden characters",
    totalChars: "Characters",
    totalWords: "Words",
    presets: "Presets",
    presetHelper: "Presets apply multiple cleaning options at once.",
    socialMedia: "Social Media",
    plainText: "Plain Text",
    webSafe: "Web / HTML Safe",
    singleLine: "Single Line",
    insufficientHearts: "You need 1 heart to use a preset.",
    presetApplied: "Preset Applied!",
    options: "Options",
    optional: "optional",
    toggleTheme: "Toggle Theme",
    toggleDarkMode: "Toggle dark mode",
    getMoreHearts: "Get more Hearts",
    getMoreBrains: "Get more Brains",
    guest: "Guest",
    systemMessage: "System Message",
    noUsersFound: "No users found matching",
    languageLabel: "Language",
    cannotChangeOwnRole: "Cannot change own role",
    currencyActions: "Currency Actions",
    referralDebug: "Referral Debug",
    localUserData: "Local User Data (DB)",
    moreFreeApps: "More free apps at Joisst.com",
    installJoisst: "Install Joisst",
    pastePlaceholder: "Paste text here...",
    subApp: "Utility",
    copyright: "Joisst Platform. All rights reserved.",
    themeSwitched: "Theme switched to",
    light: "Light",
    dark: "Dark",
    cookieTitle: "Simple Cookies (no “trackers”)",
    cookieContent: "We only use cookies to sync your hearts, brains, and preferences across the Joisst ecosystem. By clicking below, you're cool with this platform-wide synchronisation.",
    cookieButton: "Cool!",
    shareAndEarn: "Share & Earn",
    referralText: "Invite friends and earn rewards when they join the Joisst ecosystem.",
    copyLink: "Copy Invite Link"
  },
  es: {
    signIn: "Iniciar sesión con Joisst",
    continue: "Continuar como",
    dashboard: "CleanTXT",
    adminPanel: "Panel de Administración",
    welcome: "Bienvenido de nuevo",
    hearts: "Corazones",
    brains: "Cerebros",
    loading: "Cargando...",
    logout: "Cerrar sesión",
    usersList: "Gestión de Usuarios Locales",
    id: "ID",
    email: "Correo (Oculto)",
    role: "Rol",
    admin: "Admin",
    user: "Usuario",
    lastLogin: "Último acceso",
    balance: "Balance",
    tagline: "Limpieza de texto rápida y mínima. Limpia tu contenido en segundos.",
    instruction: "Pegue su texto a continuación y seleccione cómo desea que se limpie.",
    searchPlaceholder: "Buscar por ID o correo...",
    actions: "Acciones",
    toggleAdmin: "Alternar Admin",
    save: "Guardar",
    cancel: "Cancelar",
    testPage: "Herramienta de Prueba del Sistema",
    apiData: "Datos API Crudos",
    spendHeart: "Gastar 1 Corazón",
    spendBrain: "Gastar 1 Cerebro",
    inputLabel: "Texto de Entrada",
    outputLabel: "Resultado Limpio",
    clearAll: "Limpiar",
    copyText: "Copiar",
    copied: "¡Copiado!",
    removeExtraSpaces: "Eliminar espacios extra",
    removeExtraLineBreaks: "Eliminar saltos de línea extra",
    removeLineBreaks: "Eliminar todos los saltos de línea",
    trimWhitespace: "Recortar espacios al inicio y al final",
    normalizeQuotes: "Convertir comillas tipográficas",
    removeTabs: "Reemplazar tabulaciones por espacios",
    removeEmojis: "Eliminar emojis",
    removeHidden: "Eliminar caracteres ocultos",
    totalChars: "Caracteres",
    totalWords: "Palabras",
    presets: "Ajustes Preestablecidos",
    presetHelper: "Los ajustes aplican múltiples opciones a la vez.",
    socialMedia: "Redes Sociales",
    plainText: "Texto Plano",
    webSafe: "Web / HTML Seguro",
    singleLine: "Una Sola Línea",
    insufficientHearts: "Necesitas 1 corazón para usar un ajuste.",
    presetApplied: "¡Ajuste Aplicado!",
    options: "Opciones",
    optional: "opcional",
    toggleTheme: "Alternar Tema",
    toggleDarkMode: "Alternar modo oscuro",
    getMoreHearts: "Obtener más corazones",
    getMoreBrains: "Obtener más cerebros",
    guest: "Invitado",
    systemMessage: "Mensaje del Sistema",
    noUsersFound: "No se encontraron usuarios que coincidan con",
    languageLabel: "Idioma",
    cannotChangeOwnRole: "No se puede cambiar el propio rol",
    currencyActions: "Acciones de moneda",
    referralDebug: "Depuración de referidos",
    localUserData: "Datos de usuario local",
    moreFreeApps: "Más apps gratis en Joisst.com",
    installJoisst: "Instalar Joisst",
    pastePlaceholder: "Pegue el texto aquí...",
    subApp: "Utilidad",
    copyright: "Joisst Platform. Todos los derechos reservados.",
    themeSwitched: "Tema cambiado a",
    light: "Claro",
    dark: "Oscuro",
    cookieTitle: "Cookies Simples (sin “rastreadores”)",
    cookieContent: "Solo usamos cookies para sincronizar tus corazones, cerebros y preferencias en todo el ecosistema de Joisst. Al hacer clic a continuación, aceptas esta sincronización en toda la plataforma.",
    cookieButton: "¡Genial!",
    shareAndEarn: "Comparte y Gana",
    referralText: "Invita a tus amigos y gana recompensas cuando se unan al ecosistema de Joisst.",
    copyLink: "Copiar enlace de invitación"
  },
  fr: {
    signIn: "Se connecter avec Joisst",
    continue: "Continuer en tant que",
    dashboard: "CleanTXT",
    adminPanel: "Panneau d'administration",
    welcome: "Bon retour",
    hearts: "Cœurs",
    brains: "Cerveaux",
    loading: "Chargement...",
    logout: "Se déconnecter",
    usersList: "Gestion des utilisateurs locaux",
    id: "ID",
    email: "Email (Masqué)",
    role: "Rôle",
    admin: "Admin",
    user: "Utilisateur",
    lastLogin: "Dernière connexion",
    balance: "Solde",
    tagline: "Nettoyage de texte rapide et minimaliste. Nettoyez votre texte en quelques secondes.",
    instruction: "Collez votre texte ci-dessous et sélectionnez comment vous souhaitez le nettoyer.",
    searchPlaceholder: "Rechercher par ID ou email...",
    actions: "Actions",
    toggleAdmin: "Basculer Admin",
    save: "Enregistrer",
    cancel: "Annuler",
    testPage: "Outil de Test Système",
    apiData: "Données API Brutes",
    spendHeart: "Dépenser 1 Cœur",
    spendBrain: "Dépenser 1 Cerveau",
    inputLabel: "Texte d'entrée",
    outputLabel: "Résultat nettoyé",
    clearAll: "Effacer",
    copyText: "Copier",
    copied: "Copié !",
    removeExtraSpaces: "Supprimer les espaces en trop",
    removeExtraLineBreaks: "Supprimer les sauts de ligne en trop",
    removeLineBreaks: "Supprimer tous les sauts de ligne",
    trimWhitespace: "Supprimer les espaces au début et à la fin",
    normalizeQuotes: "Convertir les guillemets",
    removeTabs: "Remplacer les tabulations par des espaces",
    removeEmojis: "Supprimer les emojis",
    removeHidden: "Supprimer les caractères cachés",
    totalChars: "Caractères",
    totalWords: "Mots",
    presets: "Préréglages",
    presetHelper: "Les préréglages appliquent plusieurs options à la fois.",
    socialMedia: "Réseaux Sociaux",
    plainText: "Texte Brut",
    webSafe: "Web / HTML Sûr",
    singleLine: "Une Seule Ligne",
    insufficientHearts: "Vous avez besoin d'un cœur pour utiliser un préréglage.",
    presetApplied: "Préréglage Appliqué !",
    options: "Options",
    optional: "optionnel",
    toggleTheme: "Changer de thème",
    toggleDarkMode: "Basculer le mode sombre",
    getMoreHearts: "Obtenir plus de cœurs",
    getMoreBrains: "Obtenir plus de cerveaux",
    guest: "Invité",
    systemMessage: "Message système",
    noUsersFound: "Aucun utilisateur trouvé correspondant à",
    languageLabel: "Langue",
    cannotChangeOwnRole: "Impossible de changer son propre rôle",
    currencyActions: "Actions de devise",
    referralDebug: "Débogage de parrainage",
    localUserData: "Données utilisateur locales",
    moreFreeApps: "Plus d'apps gratuites sur Joisst.com",
    installJoisst: "Installer Joisst",
    pastePlaceholder: "Collez le texte ici...",
    subApp: "Utilitaire",
    copyright: "Joisst Platform. Tous droits réservés.",
    themeSwitched: "Thème changé en",
    light: "Clair",
    dark: "Sombre",
    cookieTitle: "Cookies simples (pas de « traceurs »)",
    cookieContent: "Nous utilisons uniquement des cookies pour synchroniser vos cœurs, vos cerveaux et vos préférences dans l'écosystème Joisst. En cliquant ci-dessous, vous acceptez cette synchronisation à l'échelle de la plateforme.",
    cookieButton: "Cool !",
    shareAndEarn: "Partagez et Gagnez",
    referralText: "Invitez vos amis et gagnez des récompenses lorsqu'ils rejoignent l'écosystème Joisst.",
    copyLink: "Copier le lien d'invitation"
  },
  de: {
    signIn: "Mit Joisst anmelden",
    continue: "Weiter als",
    dashboard: "CleanTXT",
    adminPanel: "Admin-Bereich",
    welcome: "Willkommen zurück",
    hearts: "Herzen",
    brains: "Gehirne",
    loading: "Laden...",
    logout: "Abmelden",
    usersList: "Lokale Benutzerverwaltung",
    id: "ID",
    email: "E-Mail (Maskiert)",
    role: "Rolle",
    admin: "Admin",
    user: "Benutzer",
    lastLogin: "Letzte Anmeldung",
    balance: "Guthaben",
    tagline: "Schnelle, minimalistische Textbereinigung. Bereinigen Sie Ihren Text in Sekunden.",
    instruction: "Fügen Sie Ihren Text unten ein und wählen Sie aus, wie er bereinigt werden soll.",
    searchPlaceholder: "Suche nach ID oder E-Mail...",
    actions: "Aktionen",
    toggleAdmin: "Admin umschalten",
    save: "Speichern",
    cancel: "Abbrechen",
    testPage: "Systemtest-Tool",
    apiData: "Roh-API-Daten",
    spendHeart: "1 Herz ausgeben",
    spendBrain: "1 Gehirne ausgeben",
    inputLabel: "Eingabetext",
    outputLabel: "Bereinigter Text",
    clearAll: "Leeren",
    copyText: "Kopieren",
    copied: "Kopiert!",
    removeExtraSpaces: "Zusätzliche Leerzeichen entfernen",
    removeExtraLineBreaks: "Zusätzliche Zeilenumbrüche entfernen",
    removeLineBreaks: "Alle Zeilenumbrüche entfernen",
    trimWhitespace: "Leerzeichen am Anfang und Ende kürzen",
    normalizeQuotes: "Anführungszeichen vereinheitlichen",
    removeTabs: "Tabulatoren durch Leerzeichen ersetzen",
    removeEmojis: "Emojis entfernen",
    removeHidden: "Versteckte Zeichen entfernen",
    totalChars: "Zeichen",
    totalWords: "Wörter",
    presets: "Voreinstellungen",
    presetHelper: "Voreinstellungen wenden mehrere Optionen gleichzeitig an.",
    socialMedia: "Social Media",
    plainText: "Nur Text",
    webSafe: "Web / HTML Sicher",
    singleLine: "Einzelne Zeile",
    insufficientHearts: "Sie benötigen 1 Herz, um eine Voreinstellung zu verwenden.",
    presetApplied: "Voreinstellung Angewendet!",
    options: "Optionen",
    optional: "optional",
    toggleTheme: "Thema umschalten",
    toggleDarkMode: "Dunkelmodus umschalten",
    getMoreHearts: "Mehr Herzen erhalten",
    getMoreBrains: "Mehr Gehirne erhalten",
    guest: "Gast",
    systemMessage: "Systemmeldung",
    noUsersFound: "Keine passenden Benutzer gefunden für",
    languageLabel: "Sprache",
    cannotChangeOwnRole: "Eigene Rolle kann nicht geändert werden",
    currencyActions: "Währungsaktionen",
    referralDebug: "Empfehlungs-Debugging",
    localUserData: "Lokale Benutzerdaten",
    moreFreeApps: "Weitere Gratis-Apps auf Joisst.com",
    installJoisst: "Joisst installieren",
    pastePlaceholder: "Text hier einfügen...",
    subApp: "Dienstprogramm",
    copyright: "Joisst Platform. Alle Rechte vorbehalten.",
    themeSwitched: "Thema gewechselt zu",
    light: "Hell",
    dark: "Dunkel",
    cookieTitle: "Einfache Cookies (keine „Tracker“)",
    cookieContent: "Wir verwenden Cookies nur, um Ihre Herzen, Gehirne und Einstellungen im gesamten Joisst-Ökosystem zu synchronisieren. Indem Sie unten klicken, sind Sie mit dieser plattformweiten Synchronisierung einverstanden.",
    cookieButton: "Cool!",
    shareAndEarn: "Teilen & Verdienen",
    referralText: "Lade Freunde ein und erhalte Belohnungen, wenn sie dem Joisst-Ökosystem beitreten.",
    copyLink: "Einladungslink kopieren"
  }
};